exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.link {\n  color: #000;\n  text-decoration: underline;\n}\n.select-wrapper.content-list-item-block-content-form-field select {\n  border: none;\n  width: 100%;\n  border-radius: 0;\n  background-color: transparent;\n  font-size: 18px;\n  font-family: 'TTNorms Regular', sans-serif;\n}\n", ""]);

// exports
